<template>
  <v-container>
    <template>
      <div class="text-center">
        <v-dialog
          v-model="dialog"
          width="800"
          @click:outside="closeModal"
          :retain-focus="false"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                Confirmation
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text class="black--text">
              <div class="text-center mt-10">
                <img src="/img/confirmation.svg" class="mb-5" /><br />
                <div class="mb-2"><strong>Congratulations!</strong></div>
                You have successfully requested Satellite report. We are working
                on your request.

                <div class="my-6">
                  <v-btn
                    outlined
                    class="mr-2"
                    right
                    height="44"
                    depressed
                    color="primary"
                    @click="closeModal"
                  >
                    REQUEST MORE SATELLITE REPORTS
                  </v-btn>
                  <v-btn right height="44" color="primary" class="px-16">
                    DONE
                  </v-btn>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      showConfirmDialog: false
    };
  },
  computed: {
    dialog: {
    get: function () {
      return this.showConfirmDialog;
    },
    // setter
    set: function (newValue) {
      this.showConfirmDialog = newValue
    }
    },
  },
  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    closeModal() {
      this.$emit("closeDialog");
      console.log(this.dialog)
      this.dialog = false
      console.log(this.dialog)
    },
  },
  mounted() {
    console.log(this.dialogI)
    this.showConfirmDialog = this.dialogI

  }
};
</script>

<style></style>
